import { Box, Typography } from '@mui/material';

export interface ModalDetailsProp {
  price: number
  currency: string
  displayVat: boolean
  isFlexibleOption: boolean
  additionalOptions: number | 'displayOnly'
}

const pricingBreakdownExcludeVat =
  'Price excludes VAT and may also exclude tolls, congestion/low emission zone charges, parking, airport pick-up/drop-off charges, waiting time, additional stops'

const pricingbreakdownIncludeVat =
  'Pricing includes VAT, but may be subject to waiting time, airport drop off/collection fees, parking, tolls, clean air charges and may be subject to congestion zone charges'

const ModalDetails = ({
  price,
  currency,
  displayVat,
  isFlexibleOption,
  additionalOptions,
}: ModalDetailsProp) => (
  <>
    <Box
      component="div"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #D5D5D5',
        padding: '20px 16px 0 16px',
        backgroundColor: '#FDFDFD',
        borderRadius: '4px 4px 0 0',
        marginTop: '32px',
      }}
    >
      <Box
        component="div"
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          component="p"
          sx={{
            color: '#414042',
            fontWeight: '600',
            fontSize: '17px',
            lineHeight: '21px',
          }}
        >
          Pricing Breakdown
        </Typography>
        <Typography
          component="p"
          sx={{
            color: '#414042',
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '21px',
            marginTop: '8px',
          }}
        >
          {displayVat ? pricingbreakdownIncludeVat : pricingBreakdownExcludeVat}
        </Typography>
      </Box>
      <Box
        component="div"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '20px',
          marginBottom: '12px',
        }}
      >
        <Typography
          component="p"
          sx={{
            color: '#414042',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '24px',
          }}
        >
          Base fare
        </Typography>
        <Typography
          component="p"
          sx={{
            color: '#414042',
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '21px',
            marginTop: '8px',
          }}
        >
          {`${currency} ${price.toFixed(2)}`}
        </Typography>
      </Box>
      {isFlexibleOption || typeof additionalOptions !== 'number' ? (
        <Box
          component="div"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '24px',
          }}
        >
          <Typography
            component="p"
            sx={{
              color: '#414042',
              fontWeight: '400',
              fontSize: '16px',
              lineHeight: '24px',
            }}
          >
            Additional Options
          </Typography>
          <Typography
            component="p"
            sx={{
              color: '#414042',
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '21px',
              marginTop: '8px',
            }}
          >
            {`${currency} ${
              typeof additionalOptions === 'number'
                ? additionalOptions.toFixed(2)
                : '0.00'
            }`}
          </Typography>
        </Box>
      ) : (
        <></>
      )}
    </Box>
    <Box
      component="div"
      sx={{
        display: 'flex',
        border: '1px solid #D5D5D5',
        padding: '18px 16px',
        backgroundColor: '#FDFDFD',
        justifyContent: 'space-between',
        borderTop: 0,
        borderRadius: '0 0 4px 4px',
      }}
    >
      <Typography
        component="p"
        sx={{
          color: '#414042',
          fontWeight: '400',
          fontSize: '16px',
        }}
      >
        Total Price
      </Typography>
      <Typography
        component="p"
        sx={{
          color: '#414042',
          fontWeight: '400',
          fontSize: '19px',
        }}
      >
        ESTIMATED
        <Typography
          component="span"
          sx={{
            fontWeight: '600',
          }}
        >
          {` ${currency} ${(
            price +
            (typeof additionalOptions === 'number' ? additionalOptions : 0)
          ).toFixed(2)}`}
        </Typography>
      </Typography>
    </Box>
  </>
)

export default ModalDetails
